export interface GenderSource {
  bodyProfile?: string | null;
  body_profile?: string | null;
  clientBodyProfile?: string | null;
  backgroundImageGender?: string | null;
  gender?: string | number | null;
  [key: string]: any;
}

/**
 * Resolves whether a given client, profile, or string represents a 'male' or 'female' body profile.
 * Prioritizes explicit bodyProfile / body_profile strings over legacy gender fields.
 */
export const resolveBodyProfile = (
  source?: GenderSource | string | null,
  fallback: 'male' | 'female' = 'male',
): 'male' | 'female' => {
  if (!source) return fallback;

  if (typeof source === 'string') {
    const s = source.trim().toLowerCase();
    if (s === 'female' || s === '2') return 'female';
    if (s === 'male' || s === '1') return 'male';
    return fallback;
  }

  const bp = (
    source.bodyProfile ||
    source.body_profile ||
    source.clientBodyProfile ||
    source.backgroundImageGender ||
    ''
  )
    .toString()
    .trim()
    .toLowerCase();

  if (bp === 'female') return 'female';
  if (bp === 'male') return 'male';

  const g = (source.gender ?? '').toString().trim().toLowerCase();
  if (g === 'female' || g === '2') return 'female';
  if (g === 'male' || g === '1') return 'male';

  return fallback;
};

/**
 * Returns true if the resolved body profile is 'female'.
 */
export const isFemaleProfile = (source?: GenderSource | string | null): boolean => {
  return resolveBodyProfile(source) === 'female';
};

/**
 * Returns true if the resolved body profile is 'male'.
 */
export const isMaleProfile = (source?: GenderSource | string | null): boolean => {
  return resolveBodyProfile(source) === 'male';
};
